/* VL landing v2 — use-case accordion, offer tabs and review carousel
   for sections qikify-vl2-*. Each widget is bound once per root element. */
(function () {
  function initAccordion(row) {
    var items = row.querySelectorAll('[data-qvl2-uc]');
    var images = row.querySelectorAll('[data-qvl2-uc-image]');

    function showImage(index) {
      var match = row.querySelector('[data-qvl2-uc-image="' + index + '"]');
      images.forEach(function (img) {
        img.hidden = match ? img !== match : img.getAttribute('data-qvl2-uc-image') !== 'default';
      });
    }

    function open(index) {
      items.forEach(function (item, i) {
        var isOpen = i === index;
        item.classList.toggle('is-open', isOpen);
        item.querySelector('button').setAttribute('aria-expanded', isOpen);
        item.querySelector('[data-qvl2-uc-panel]').hidden = !isOpen;
      });
      showImage(index);
    }

    items.forEach(function (item, i) {
      item.querySelector('button').addEventListener('click', function () {
        open(item.classList.contains('is-open') ? -1 : i);
      });
    });
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    var panels = root.querySelectorAll('[role="tabpanel"]');

    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on);
        tab.tabIndex = on ? 0 : -1;
        panels[i].hidden = !on;
      });
      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        select((i + step + tabs.length) % tabs.length, true);
      });
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-qvl2-track]');
    if (!track) return;
    var dots = root.querySelectorAll('[data-qvl2-dot]');
    var gap = parseFloat(getComputedStyle(track).columnGap) || 20;

    function step() {
      var first = track.firstElementChild;
      return first ? first.offsetWidth + gap : track.clientWidth;
    }

    function goTo(n) {
      var card = track.children[n];
      if (card) track.scrollTo({ left: card.offsetLeft - track.firstElementChild.offsetLeft });
    }

    function scrollBy(dir) {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft + dir * step();
      if (x > max + 2) x = 0;
      else if (x < -2) x = max;
      track.scrollTo({ left: x });
    }

    function syncDots() {
      var max = track.scrollWidth - track.clientWidth;
      var current = track.scrollLeft >= max - 2 ? track.children.length - 1 : Math.round(track.scrollLeft / step());
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === current); });
    }

    var prev = root.querySelector('[data-qvl2-prev]');
    var next = root.querySelector('[data-qvl2-next]');
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
    track.addEventListener('scroll', syncDots, { passive: true });
    syncDots();
  }

  // Counts "1,200+" up from 0 when it scrolls into view; text around the number is kept.
  function initCount(el) {
    var match = el.textContent.trim().match(/^(\D*)(\d[\d,]*(?:\.\d+)?)(.*)$/);
    if (!match || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var prefix = match[1];
    var suffix = match[3];
    var target = parseFloat(match[2].replace(/,/g, ''));
    var decimals = (match[2].split('.')[1] || '').length;
    var grouped = match[2].indexOf(',') !== -1;
    var duration = parseInt(el.getAttribute('data-qvl2-count-duration'), 10) || 1200;

    function format(n) {
      var text = n.toFixed(decimals);
      if (grouped) {
        var parts = text.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        text = parts.join('.');
      }
      return prefix + text + suffix;
    }

    function run() {
      var start = null;
      function step(now) {
        if (start === null) start = now;
        var t = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = format(target * eased);
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) return;
    el.textContent = format(0);
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      run();
    }, { threshold: 0.4 });
    observer.observe(el);
  }

  function init(scope) {
    scope.querySelectorAll('[data-qvl2-count]:not([data-qvl2-ready])').forEach(function (el) {
      el.setAttribute('data-qvl2-ready', '');
      initCount(el);
    });
    scope.querySelectorAll('[data-qvl2-accordion]:not([data-qvl2-ready])').forEach(function (el) {
      el.setAttribute('data-qvl2-ready', '');
      initAccordion(el);
    });
    scope.querySelectorAll('[data-qvl2-tabs]:not([data-qvl2-ready])').forEach(function (el) {
      el.setAttribute('data-qvl2-ready', '');
      initTabs(el);
    });
    scope.querySelectorAll('[data-qvl2-carousel]:not([data-qvl2-ready])').forEach(function (el) {
      el.setAttribute('data-qvl2-ready', '');
      initCarousel(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
